<template>
    <div id="navMenuBox">
        <div class="closeIcon" @click="$emit('menuopen')">
            <img :src="getStaticImage('icons/menu/closeIcon.png')">
        </div>
        
        <div class="loginBox" v-if="user" @click="$emit('menuopen')">
            <router-link :to="{name: 'AccountInformation'}">
                <span>{{user.first_name}} {{user.last_name}}</span>
                {{user.email}}
            </router-link>
        </div>
        <div class="loginBox d-flex mt-5" v-else @click="$emit('menuopen')">
            <router-link class="btnlink mr-3 smlpad" :to="{name:'Registration'}">Join</router-link>
            <router-link class="btnlink inv smlpad" :to="{name:'Login'}">Log in</router-link>
        </div>
        <div class="navMenu">
            <div v-for="item in items" @click="$emit('menuopen')">
                <router-link :to="{name: item.name}">
                    <img :src="getStaticImage('icons/nav/' + ( item.image ? item.image : 'demoicon_selected') +'.png')" alt="">
                    {{ item.title || item.name}}
                </router-link>
            </div>
        </div>
        
        <div class="socialIcons">
            <a target="_system" class="px-2" href="https://www.facebook.com/KettlemansBagel/">
                <img :src="getStaticImage('icons/social/facebook.png')">
            </a>
            <a target="_system" class="px-2" href="https://twitter.com/bagelottawa">
                <img :src="getStaticImage('icons/social/twitter.png')">
            </a>
            <a target="_system" class="px-2" href="https://www.instagram.com/kettlemans/">
                <img :src="getStaticImage('icons/social/instagram.png')">
            </a>
        </div>
        <div class="additionLinks">
            <div @click="$emit('menuopen')">
                <router-link :to="{name: 'Faqs'}">
                    FAQ
                </router-link>
            </div>
            <div>
                <a href="https://www.kettlemansbagels.ca/contact/" target="_system">
                    Contact Us
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Nav",
        props: ['menuopen'],
        data() {
            return {
                items: {
                    home: {name: "Home", image: "home"},
                    menu: {name: "Locations", title: "Order Online", image: "order"},
                    //location: {name: "Locations", title: "Locations", image: "location"},
                    rewards: {name: "OrderHistory", title: "Order History", image: "order-history"},
                    //rewardshistory: {name: "home", title: "Reward History", image: "rewards"},
                    transaction: {name: "Transaction History", image: "transaction"},
                    gift_card_history: {name: "ManageCards", title: "Gift Card History", image: "gift-history"},
                    gifts: {name: "E-gifts", image: "egifts"}
                }
            }
        }
    }
</script>
